import { Server } from '../types/server'

export function buildMockServer({
  name = 'localhost',
  environment,
  applications,
  assess = false,
  tags = [],
  license = null,
  language = null,
  logPath,
  online = false,
  hostname = 'Test hostname',
  logLevel = 'INFO',
  path = '/var/www',
  firstActivity = '1524734553027',
  lastActivity = '1524734553027',
  agentVersion = '3.5.3',
  latestAgentVersion = '3.5.3',
  outOfDate = false,
  diagnosticCollectionEnabled = false,
  syslogConfig = {
    enabled: false,
    ipAddress: '12.12.12.12'
  },
  sampling = {
    enabled: false
  },
  protect = false,
  stacktraceCaptureMode = 'ALL'
}: Partial<Server>): Server {
  return {
    id: 'id',
    name,
    environment: environment || 'QA',
    applications: applications || [
      {
        id: 'id|id',
        applicationUuid: 'id',
        name: 'app 1',
        language: 'Node',
        importance: 'CRITICAL',
        path: '/app'
      }
    ],
    assess,
    tags,
    license,
    online,
    hostname,
    logLevel,
    logPath,
    path,
    firstActivity,
    lastActivity,
    agentVersion,
    latestAgentVersion,
    outOfDate,
    language,
    syslogConfig,
    protect,
    sampling,
    botProtection: false,
    stacktraceCaptureMode,
    diagnosticCollectionEnabled
  }
}

export const mockServers = [
  buildMockServer({
    name: 'Server 1',
    language: 'Java'
  }),
  buildMockServer({
    name: 'Server 2',
    language: 'Node',
    assess: true,
    applications: [
      {
        id: '2|id',
        applicationUuid: '2',
        name: 'node app',
        language: 'Node',
        importance: 'CRITICAL',
        path: '/node'
      }
    ]
  }),
  buildMockServer({
    name: 'Server name long server name long name long name long name',
    language: 'Java',
    applications: [
      {
        id: 'id 1|id',
        applicationUuid: 'id 1',
        name: 'Some Node App with a Very Long Name - 1234 - 4567 - ABCD',
        language: 'Node',
        importance: 'HIGH',
        path: '/node'
      },
      {
        id: 'id 2|id',
        applicationUuid: 'id 2',
        name: 'Java app',
        language: 'Java',
        importance: 'CRITICAL',
        path: '/jaba'
      },
      {
        id: 'id 3|id',
        applicationUuid: 'id 3',
        name: 'node app again',
        language: 'Node',
        importance: 'LOW',
        path: '/node/again'
      },
      {
        id: 'id 4|id',
        applicationUuid: 'id 4',
        name: 'node app once again',
        language: 'Node',
        importance: 'LOW',
        path: '/node/again/again'
      }
    ]
  }),
  buildMockServer({
    name: 'Server name with a lot of tags and a long name',
    tags: [
      'tag',
      'another tag',
      'yet another tag',
      'one more for good measure'
    ],
    license: {
      expiration: new Date(2030, 10, 10).toISOString()
    }
  }),
  buildMockServer({
    name: 'Server with assess',
    language: 'Java',
    assess: true,
    environment: 'DEVELOPMENT',
    hostname: 'thisisaserver.local'
  }),
  buildMockServer({
    name: 'Logs to Syslog',
    language: 'Java',
    syslogConfig: {
      enabled: true,
      ipAddress: '86.75.30.9'
    }
  }),
  buildMockServer({
    name: 'No Language'
  }),
  buildMockServer({
    name: 'Unsupported Protect Language',
    language: 'Python'
  }),
  buildMockServer({
    name: 'Unsupported Assess Language',
    language: 'Python'
  }),
  buildMockServer({
    name: 'Server with outdated agent',
    language: 'Python',
    outOfDate: true,
    agentVersion: '3.4.9',
    latestAgentVersion: '3.5.3'
  }),
  buildMockServer({
    name: 'Server with outdated agent and cannot autoupdate',
    language: 'Java',
    outOfDate: true,
    agentVersion: '3.6.1',
    latestAgentVersion: '3.7.3'
  })
]
